import { httpRequest } from "../../../utils/HttpRequest";
import { IPage, ISearchPage } from "@/types/ScmTypes";
import { IPurchaseRoFields, IPurchaseRoList, IPurchaseRoDetail, IPurchaseDetailsSearch, IPurchaseDetails, IPurchaseRoSearch, Detailed, IPurchaseRoSettleAndWhConfirm } from "./purchaseRoType"
class PurchaseRoService {
    async page(searchVo: IPurchaseRoSearch) {
        const apiUrl = "/vrm-sa/preturn/findPage";
        return await httpRequest.post<IPurchaseRoList>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/vrm-sa/preturn/findById/${id}`;
        return await httpRequest.get<IPurchaseRoDetail>(apiUrl);
    }
    async insert(insertVo: IPurchaseRoFields) {
        const apiUrl = "/vrm-sa/preturn/insert";
        return await httpRequest.post<IPurchaseRoDetail>(apiUrl, insertVo);
    }
    async update(updateVo: IPurchaseRoFields) {
        const apiUrl = "/vrm-sa/preturn/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //作废
    async invalidate(params: IPurchaseRoSettleAndWhConfirm) {
        const apiUrl = "/vrm-sa/preturn/invalidate";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //库房确认
    async delivery(params: IPurchaseRoSettleAndWhConfirm) {
        const apiUrl = "/vrm-sa/preturn/warehousing";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //结算
    async settl(params: IPurchaseRoSettleAndWhConfirm) {
        const apiUrl = "/vrm-sa/preturn/settle";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //批量删除明细
    async materialDelete(params: Detailed) {
        const apiUrl = "/vrm-sa/preturn/materialDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //分页查询采购单详情列表
    async purchaseDetails(params: IPurchaseDetailsSearch) {
        const apiUrl = "/vrm-sa/purchase/details/findPage";
        return await httpRequest.post<IPage<IPurchaseDetails>>(apiUrl, params);
    }
    //采购退货单批量导出
    async export(params: IPurchaseRoSearch) {
        const apiUrl = "/vrm-sa/preturn/export";
        return await httpRequest.postFile(apiUrl, params, { timeout: 600000 });
    }
    //采购退货单详情导出
    async detailsExport(params: object) {
        const apiUrl = "/vrm-sa/preturn/detailsExport";
        return await httpRequest.postFile(apiUrl, params, { timeout: 600000 });
    }
}

export const purchaseRoService = new PurchaseRoService();